<template>
    <div class="item-table__item">
        <div class="image">
            <router-link :to="'/catalog/product/' + item.slug">
                <img :src="'https://app.skybase.ru/public/actions/39947490820098?fileid=' + item.code + '-f64'" alt="">
            </router-link>
        </div>
        <div class="pr-2">
            <router-link :to="'/catalog/product/' + item.slug">
                {{item.name}}
            </router-link>
        </div>

        <div v-if="item.discount_flag != null && item.discount_flag == 1" class="d-none d-lg-block">{{item.discount_new_price}} RUB</div>
        <div v-else class="d-none d-lg-block">{{item.day_price}} RUB</div>

        <div class="d-none d-xl-block" v-if="item.discount_flag == 0">
            <span v-if="item.discount">{{ item.discount }}%</span>
            <span v-else-if="item.not_apply_discount == 0">{{store.common_price.discount}}%</span>
            <span v-else>0%</span>
        </div>

        <div class="d-none d-xl-block" v-else>
            <span>0%</span>
<!--            <span>{{ Math.round((item.discount_old_price - item.discount_new_price) * 100 / item.discount_old_price) }}%</span>-->
        </div>


        <div class="d-flex align-items-center">
            <button class="count-btn" @click="countDecrease()" :disabled="true ? count == 1 : count > 1">
                <img src="/svg/count-less.svg" alt="">
            </button>
            <span class="pl-1 pr-1">{{count}}</span>
            <button class="count-btn" @click="countIncrease()"> <img src="/svg/count-more.svg" alt=""></button>

        </div>

        <div class="d-none d-lg-block">{{getFinalPrice(item.discount_flag, item.discount_new_price)}} RUB</div>

        <div class="d-none d-lg-block">{{discount_price}} RUB</div>


        <div>{{priceAfterDiscount}} RUB</div>

        <div class="close" @click="removeItem()"><img src="/svg/close-small.svg" alt=""></div>
    </div>
</template>


<script>
    import store from '../../../services/data'
    export default {
        props: ['item'],
        data() {
            return {
                store: store,
                count: null,
            }
        },

        mounted() {
            this.count = this.item.count
        },

        computed: {
            user() {
                return this.$store.getters.getUser;
            },
            discount_price() {
                if (this.item.discount_flag == 1) {
                    return 0;
                    // return  this.getFinalPrice(true, this.item.discount_old_price) -  this.getFinalPrice(true, this.item.discount_new_price);
                }
                else if (this.item.discount) return Math.round(this.getFinalPrice(false, 0) * this.item.discount / 100);
                else if (this.item.not_apply_discount == 0) return Math.round(this.getFinalPrice(false, 0) * this.discount_size / 100);

                return 0;
            },


            priceAfterDiscount() {
                if (this.item.discount_flag != null && this.item.discount_flag == 1) {
                    return this.getFinalPrice( this.item.discount_flag, this.item.discount_new_price);
                }
                return this.getFinalPrice(false, 0) - this.discount_price;
            },
            discount_size() {
                // if (this.item.discount_flag != null && this.item.discount_flag == 1) {
                //     return Math.round((item.discount_old_price - item.discount_new_price) * 100 / item.discount_old_price);
                // }
                return this.store.common_price.discount
            },

        },

        methods: {
            getFinalPrice(flag, current_discount_price) {
                return this.store.getFinalPrice(this.item.threeHoure_price, this.item.day_price, this.count, this.item.not_apply_number_days, flag == 1 ? true : false , current_discount_price == null ? 0 : current_discount_price);
            },

            removeItem() {
                let storage_item = JSON.parse(this.store.getItemlocalStorage('chosen-products'));

                let count = -1;
                storage_item.forEach(i => {
                    count++;
                    if (i.code == this.item.code) storage_item.splice(count, 1);
                });


                this.store.setItemlocalStorage('chosen-products', storage_item);
                this.$emit('update', true);
                this.store.getCommonPrice();
                this.store.state.basket_count = storage_item.length;
            },

            countDecrease() {
                this.count --;

                let storage_item = JSON.parse(this.store.getItemlocalStorage('chosen-products'));
                storage_item.forEach(item => {
                    if(item.code == this.item.code) item.count = this.count;
                });
                this.store.state.basket_items.forEach(item => {
                    if(item.code == this.item.code) item.count = this.count;
                });
                this.store.setItemlocalStorage('chosen-products', storage_item);
                this.store.getCommonPrice();
            },
            countIncrease() {
                this.count ++;

                let storage_item = JSON.parse(this.store.getItemlocalStorage('chosen-products'));
                storage_item.forEach(item => {
                    if(item.code == this.item.code) item.count = this.count;
                });
                this.store.state.basket_items.forEach(item => {
                    if(item.code == this.item.code) item.count = this.count;
                });
                this.store.setItemlocalStorage('chosen-products', storage_item);
                this.store.getCommonPrice();
            }
        },
    }
</script>
